// extracted by mini-css-extract-plugin
export var brand = "_4p-9";
export var compact = "_4p-6";
export var extraSmall = "_4p-7";
export var icon = "_4p-0";
export var large = "_4p-4";
export var light = "_4p-1";
export var medium = "_4p-5";
export var outline = "_4p-b";
export var primaryDark = "_4p-a";
export var primaryLight = "_4p-8";
export var primaryModern = "_4p-c";
export var success = "_4p-2";
export var successSolid = "_4p-3";